export default function classesToSelector(classes){if(classes===void 0){classes='';}return".".concat(classes.trim().replace(/([\.:!\/])/g,'\\$1')// eslint-disable-line
.replace(/ /g,'.'));}